import { render, staticRenderFns } from "./ReportsDeliverySacBostonPublicView.vue?vue&type=template&id=480093d8"
import script from "./ReportsDeliverySacBostonPublicView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySacBostonPublicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports